import React, { useEffect, useState } from "react";
import * as API from "lib/apis";
import { logo_bdan, welcome_bdan } from "styles/img";
import Loader from "components/Loader";

const CertificationStart = (props) => {
  const searchParam = new URLSearchParams(props.location.search);
  const ci = searchParam.get("ci");
  const membershipId = searchParam.get("membershipId");

  const [encData, setEncData] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getEncData();
    window.history.back = function () {
      window.location.href = "WEB_EXIT_EVENT";
    };
  }, []);

  const getEncData = () => {
    API.getCertificationEncData({ ci, membershipId }, ({ data }) => {
      setEncData(data);
      setIsLoading(false);
    });
  };

  function fnPopup() {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }

    document.form_chk.action =
      "https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb";
    document.form_chk.target = "_self";
    document.form_chk.submit();
  }

  function back() {
    window.location.href = "WEB_EXIT_EVENT";
  }

  return (
    <>
      {isLoading && <Loader />}
      <div className="hana_wrap">
        {/* 
        <div className="intro_top">
          <div className="intro_top_view">
            <h1>서비스 이용하기</h1>
            <span className="top_close_btn" onClick={back}>
              이전
            </span>
          </div>
        </div> */}

        <div className="hana_intro">
          <div className="img_wrap welcome">
            <img
              src={welcome_bdan}
              alt="비단에 오신 것을 환영합니다."
              width="249"
              height="138"
            />
          </div>
          <div className="btn_area fixed">
            <div className="bt_col1">
              <input
                type="button"
                value="본인 인증 하고 서비스 이용하기"
                className="navy pop"
                onClick={fnPopup}
              />
              <input
                type="button"
                value="돌아가기"
                className="none navy pop"
                onClick={back}
              />
            </div>
          </div>
        </div>
      </div>
      <form name="form_chk" method="post" style={{ visibility: "hidden" }}>
        <input type="text" readOnly name="m" value="checkplusService" />
        <input type="text" readOnly name="EncodeData" value={encData} />
        <input type="text" readOnly name="param_r1" value={membershipId} />
        <input type="text" readOnly name="param_r2" value="" />
        <input type="text" readOnly name="param_r3" value="DATA3" />
      </form>
    </>
  );
};

export default CertificationStart;
